import React from 'react';
export function Hero() {
  const scrollToPricing = () => {
    const el = document.getElementById('pricing');
    if (el) {
      const top = el.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top,
        behavior: 'smooth'
      });
    }
  };
  return <>
      {/* Barra Superior Minimalista Full Width */}
      <div className="bg-[#630E12] text-white text-center py-2.5 px-4" data-id="element-122">
        <p className="font-heading text-sm font-medium tracking-widest uppercase" data-id="element-123">
          ⭐ EL SISTEMA N.1 DE FORMACIÓN PARA INSTRUCTORAS EN ESPAÑA
        </p>
      </div>

      <div className="pt-6 pb-6 px-4 max-w-4xl mx-auto text-center" data-id="element-124">
        <h1 className="font-display text-brand-title md:text-6xl font-bold tracking-tight mb-4 text-[36px] leading-tight" data-id="element-125">
          Deja de regalar tus noches a la planificación.
        </h1>

        <div className="my-4 flex justify-center" data-id="element-126">
          <img src="https://cdn.magicpatterns.com/uploads/q6Eabv4Ek1aVnRwGDcX6Xt/mockup_sevillanas_webp-removebg-preview.webp" alt="El Manual del Instructor de Sevillanas PRO" width="800" height="800" fetchPriority="high" loading="eager" decoding="async" className="w-full max-w-2xl" style={{
          filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.25))'
        }} data-id="element-127" />
        </div>

        <p className="text-lg md:text-xl text-brand-subtitle font-semibold mb-6 max-w-2xl mx-auto" data-id="element-128">
          El sistema probado en España para preparar tus clases en 5 minutos y
          recuperar tu tiempo libre.
        </p>

        <button onClick={scrollToPricing} className="bg-gradient-red hover:opacity-90 text-white font-bold text-xl md:text-2xl py-4 px-8 rounded-btn transition-opacity w-full md:w-auto mb-3 tracking-wide shadow-red-glow" data-id="element-129">
          SÍ, QUIERO MI MANUAL POR SOLO 13,99€ →
        </button>

        <div className="text-brand-textMuted font-medium text-sm tracking-wide" data-id="element-130">
          ⚡ Acceso Instantáneo • 💳 Pago Único • 🛡️ Garantía Total
        </div>
      </div>
    </>;
}